"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const faqs = [{
    id: "faq-1",
    question: "What accounting services does Sloane offer?",
    answer: "Sloane provides comprehensive accounting and bookkeeping, tax planning and advisory, payroll services, financial consulting, and business formation and structuring support tailored to your needs."
  }, {
    id: "faq-2",
    question: "How do I get started with Sloane?",
    answer: "Simply contact us via phone at +44 20 7946 0958 or email contact@sloane.co.uk to schedule an initial consultation. We'll discuss your requirements and create a customized plan for your business."
  }, {
    id: "faq-3",
    question: "What are your business hours?",
    answer: "We are open Monday to Friday from 9am to 5:30pm. Our offices are closed on Saturdays and Sundays. For urgent matters outside these hours, please leave a message and we'll respond promptly."
  }, {
    id: "faq-4",
    question: "Do you work with small businesses and individuals?",
    answer: "Yes, we serve both businesses of all sizes and individuals. Our tailored financial solutions are designed to meet the unique needs of startups, established companies, and personal clients alike."
  }, {
    id: "faq-5",
    question: "Where is Sloane located?",
    answer: "Our office is located at Sloane House, 123 Business Rd, London, SW1A 1AA, United Kingdom. We serve clients throughout London and the surrounding areas."
  }, {
    id: "faq-6",
    question: "What makes Sloane different from other accounting firms?",
    answer: "We combine modern, proactive accounting with professional expertise and clear communication. Our bright, client-focused approach and transparent pricing set us apart, ensuring you receive dedicated support and tailored solutions."
  }];
  return <section id="frequently-asked-questions" className="w-full bg-dark-section text-dark-foreground py-24 md:py-32" ref={ref}>
      <div className={`max-w-4xl mx-auto px-4 md:px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-center mb-12 md:mb-16">
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="w-full space-y-2">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-b border-border-strong/30 last:border-b-0">
              <AccordionTrigger className="text-[16px] md:text-[18px] font-semibold text-dark-foreground hover:text-primary transition-colors duration-[var(--duration-fast)] py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[16px] leading-[1.6] text-dark-foreground/90 pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}